<template>
  <a-dropdown
    ><span class="current-sort" @mouseleave="closeDropdown">
      <div class="sort-box" @mouseenter="showDropdown">
        {{ currentSort.name }}<i :class="flg ? 'icon-up' : 'icon-down'"></i></div
    ></span>
    <template #overlay>
      <ul class="upload_dropdown" @mouseenter="showDropdown">
        <li
          @click="changeSort(item)"
          v-for="item in sortConfig"
          :key="item.key"
          :data-rlog="item.rlogKey"
        >
          {{ item.name }}
        </li>
      </ul>
    </template>
  </a-dropdown>
</template>

<script>
import { ref } from 'vue';

export default {
  emits: ['sort', 'filterTask'],
  props: {
    hideIcon: {
      type: Boolean,
      default: false,
    },
    rlogKey: String,
  },
  setup(props, context) {
    const flg = ref(false);
    const currentSort = ref({ name: '全部任务', key: 'all' });
    const sortConfig = [
      {
        key: 'all',
        name: '全部任务',
        rlogKey: 'list_chose_click_all',
      },
      {
        key: 'complete',
        name: '已完成',
        rlogKey: 'list_chose_click_done',
      },
      {
        key: 'running',
        name: '进行中',
        rlogKey: 'list_chose_click_on',
      },
    ];
    function changeSort(sortItem) {
      flg.value = false;
      currentSort.value = sortItem;
      context.emit('filterTask', sortItem.key);
    }
    function showDropdown() {
      flg.value = true;
    }
    function closeDropdown() {
      flg.value = false;
    }

    return {
      flg,
      sortConfig,
      changeSort,
      currentSort,
      showDropdown,
      closeDropdown,
    };
  },
};
</script>

<style lang="scss" scoped>
.current-sort {
  cursor: pointer;
  position: absolute;
  line-height: 17px;
  top: 20px;
  right: 40px;
  color: #212327;
  font-size: 15px;
  display: flex;
  align-items: center;
}
.sort-box {
  width: 140px;
  height: 48px;
  color: #212327;
  padding-left: 20px;
  padding-right: 20px;
  border: 1px solid #dfdfe0;
  border-radius: 8px;
  font-size: 15px;
  line-height: 48px;
}
.icon-down {
  position: absolute;
  width: 7px;
  height: 7px;
  right: 18px;
  top: 18px;
  border-left: 2px solid #212327;
  border-bottom: 2px solid #212327;
  transform: rotate(-45deg);
}
.icon-up {
  position: absolute;
  width: 7px;
  height: 7px;
  right: 18px;
  top: 22px;
  border-left: 2px solid #212327;
  border-bottom: 2px solid #212327;
  transform: rotate(135deg);
}
.upload_dropdown {
  width: 140px;
  height: 142px;
  padding-top: 10px;
  box-shadow: 0px 16px 30px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  background: #ffffff;
  li {
    height: 42px;
    padding-left: 20px;
    font-size: 15px;
    line-height: 42px;
    color: #212327;
    cursor: pointer;
    &:hover {
      background: $grey4;
    }
  }
}
</style>
